import AppDataStore from "../app-data";

const ACCESS_TOKEN = "ACCESS_TOKEN";
let currAccessTokenListener = undefined;

function onAccessTokenUpdate(e) {
    console.log(e);
    const accessToken = e.detail.accessToken;
    AppDataStore.save(ACCESS_TOKEN, accessToken);
    accessToken && currAccessTokenListener && currAccessTokenListener.call(undefined, accessToken);
}

window.addEventListener(ACCESS_TOKEN, onAccessTokenUpdate);

export function setOnAccessTokenUpdateEventListener(listener) {
    currAccessTokenListener = listener;
    const token = AppDataStore.get(ACCESS_TOKEN);
    // notify listener immediately for the existing token
    token && currAccessTokenListener.call(undefined, token);
}

export function clearOnAcessTokenUpdateListener(listener) {
    // clear if currOnScanListener is same
    if (currAccessTokenListener === listener) {
        currAccessTokenListener = undefined;
    }
}

export async function getAccessToken() {
    // TODO handle REFRESH_BEFORE_TIME here and return the new token
    return AppDataStore.get(ACCESS_TOKEN);
}



// WEBPACK FOOTER //
// ./src/bridge/access-token.js